﻿import $ from "jquery";
(window as any).$ = $;
(window as any).jQuery = $;

import "jquery-validation";
import "jquery-validation-unobtrusive";